import { MultiSelectProps, MultiSelect } from "@mantine/core"
import { useSuspenseQueryGet } from "../typed-client/hooks/use-suspense-query-get"

interface ContractApprovalStatusMultiSelectProps
  extends Omit<MultiSelectProps, "data" | "value" | "onChange"> {
  value?: number[]
  onChange?: (value: number[]) => void
}

export function ContractApprovalStatusMultiSelect({
  value,
  onChange,
  ...props
}: ContractApprovalStatusMultiSelectProps) {
  const { data } = useSuspenseQueryGet(
    "/api/ContractApprovalStatus/GetSimpleContractApprovalStatuses",
    null
  )
  return (
    <MultiSelect
      data={data.map((c) => ({
        label: c.name,
        value: c.contractApprovalStatusId.toString(),
      }))}
      value={value?.map(String) || []}
      onChange={(v) => onChange?.(v.map(Number))}
      {...props}
    />
  )
}
